import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import { MapCenterPin } from '../../components/locations/MapCenterPin';

const mapContainerStyle = {
  width: '100%',
  height: '100%',
};

interface LocationMapViewProps {
  apiKey?: string;
  latitude?: number;
  longitude?: number;
}

// Read-only "here's where we are" map for the public page - no click-to-move, no editing.
// Uses the same script loader id as LocationMapInlineEditor so the Google Maps script is
// only ever loaded once even if both happened to render on the same page.
export const LocationMapView: React.FC<LocationMapViewProps> = ({ apiKey, latitude, longitude }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'rentman-google-maps-script',
    googleMapsApiKey: apiKey || '',
  });

  if (!apiKey || latitude == null || longitude == null || loadError) {
    return null;
  }

  const position = { lat: latitude, lng: longitude };

  return (
    <Box sx={{ height: '100%', minHeight: 260, borderRadius: 3, overflow: 'hidden' }}>
      {isLoaded ? (
        <Box sx={{ position: 'relative', height: '100%' }}>
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={position}
            zoom={15}
            options={{
              streetViewControl: false,
              mapTypeControl: false,
              fullscreenControl: false,
              cameraControl: false,
              zoomControl: true,
              gestureHandling: 'cooperative',
            }}
          />
          <MapCenterPin />
        </Box>
      ) : (
        <Box
          sx={{
            height: '100%',
            minHeight: 260,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'grey.100',
          }}
        >
          <CircularProgress size={24} />
        </Box>
      )}
    </Box>
  );
};
